import Chart from 'chart.js'

class PixelScale extends Chart.scaleService.constructors.linear {
    constructor(...args) {
        super(...args)
    }

    // Get the pixel (x coordinate for horizontal axis, y coordinate for vertical axis) for a given value
    // @param value : the value to get the pixel for
    // @param index : index into the data array of the value
    // @param datasetIndex : index of the dataset the value comes from
    getPixelForValue(value) {
        return this.bottom - value.y
    }

    // Get the value for a given pixel (x coordinate for horizontal axis, y coordinate for vertical axis)
    // @param pixel : pixel value
    getValueForPixel(pixel) {
        return pixel
    }
}

export default PixelScale
